module.exports = __webpack_public_path__ + "static/app-store-badge-64dfa85089f6c0b25c9d78c45e2c91cc.png";